import ButtonBase from '@mui/material/ButtonBase';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { LinkProps } from 'react-router-dom';

import { useLogout } from '@/hooks/useLogout';

export const SignOutLink: React.FC<React.PropsWithChildren<Pick<LinkProps, 'to'>>> =
  React.forwardRef(function SignOutLink(
    props: React.PropsWithChildren<Pick<LinkProps, 'to'>>,
    ref: React.Ref<HTMLButtonElement>,
  ): React.ReactElement {
    const { children } = props;
    const logout = useLogout();

    return (
      <ButtonBase ref={ref} sx={styles.container} disableRipple={true} onClick={logout}>
        {children}
      </ButtonBase>
    );
  });

const styles: Record<string, SystemStyleObject> = {
  container: {
    width: '100%',
  },
};
